import displayPost from './partials/DisplayPost.vue';
import blogDashboardLayout from './partials/BlogDashboardLayout.vue';
import displayPosts from './partials/DisplayPosts.vue';
import blogTagList from './partials/BlogTagList.vue';

export default {
  components: {
    blogDashboardLayout,
    displayPost,
    displayPosts,
    blogTagList,
  },
};
